import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const NAV = [
  { label: 'About', path: '/about' },
  { label: 'Connect', path: '/connect' },
  { label: 'Sermons', path: '/sermons' },
  { label: 'Events', path: '/events' },
  { label: 'Give', path: '/give' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isHome = location.pathname === '/';
  const solid = scrolled || !isHome || open;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${solid ? 'bg-[#0b2027]/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <Logo light={true} />

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link text-white/90 hover:text-white text-sm uppercase tracking-[0.18em] font-500 transition-colors ${location.pathname === item.path ? 'active text-white' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => navigate('/plan-your-visit')}
            className="btn-shine border border-[#c9a24b] text-[#c9a24b] hover:bg-[#c9a24b] hover:text-[#0b2027] px-6 py-3 text-xs uppercase tracking-[0.2em] font-600 transition-all duration-300"
          >
            Plan Your Visit
          </button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-500 ${open ? 'max-h-[420px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`}>
        <nav className="flex flex-col px-6 pb-6 gap-1">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="text-white/90 py-3 border-b border-white/10 uppercase tracking-[0.16em] text-sm"
            >
              {item.label}
            </Link>
          ))}
          <button
            onClick={() => navigate('/plan-your-visit')}
            className="mt-4 border border-[#c9a24b] text-[#c9a24b] px-6 py-3 text-xs uppercase tracking-[0.2em]"
          >
            Plan Your Visit
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
